const ViewForm = () => {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 20.5C2.16667 20.5 1.45833 20.2083 0.875 19.625C0.291667 19.0417 0 18.3333 0 17.5V14.5H3V0.5H18V17.5C18 18.3333 17.7083 19.0417 17.125 19.625C16.5417 20.2083 15.8333 20.5 15 20.5H3ZM15 18.5C15.2833 18.5 15.5208 18.4042 15.7125 18.2125C15.9042 18.0208 16 17.7833 16 17.5V2.5H5V14.5H14V17.5C14 17.7833 14.0958 18.0208 14.2875 18.2125C14.4792 18.4042 14.7167 18.5 15 18.5ZM6 7.5V5.5H15V7.5H6ZM6 10.5V8.5H15V10.5H6ZM3 18.5H12V16.5H2V17.5C2 17.7833 2.09583 18.0208 2.2875 18.2125C2.47917 18.4042 2.71667 18.5 3 18.5ZM3 18.5H2H12H3Z"
        fill="white"
      />
    </svg>
  );
};

export default ViewForm;
